import { render, staticRenderFns } from "./messageReportItem.vue?vue&type=template&id=48892aea"
import script from "./messageReportItem.vue?vue&type=script&lang=js"
export * from "./messageReportItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports